<template>
<v-app>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-card-title primary-title>
          <div>
            <h3 class="headline">Ooops</h3>
            <div>Something went wrong, please contact us at <a href="mailto:info@tryworktabs.com">info@tryworktabs.com</a></div>
            <router-link :to="{name: 'Home'}">Go to App</router-link>
          </div>
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
</v-app>
</template>
<script>
export default {
  name: 'NotFound'
}
</script>

<style>
</style>
